import { render, staticRenderFns } from "./AboutMeCard.vue?vue&type=template&id=14b226b7&"
import script from "./AboutMeCard.vue?vue&type=script&lang=js&"
export * from "./AboutMeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports